module.exports = __webpack_public_path__ + "app/docrepo-invoice/detail/docrepo-invoice-tabs-3m4C2kc8.html";